<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<div class="card-title">素材信息列表</div>
			<div class="row-me row-center">
				<div class="width300 demo-input-size">
					<el-input placeholder="素材名称" style="width: 100%;" v-model="keyword" :prefix-icon="Search"></el-input>
					
				</div>
				<el-form-item label="素材分类"  class="margin-left30 margin-top20 width300">
					<div class="block">
						<el-cascader
							:options="classTableData"
							:props="{ checkStrictly: true , emitPath:false }"
							clearable 
							v-model="classSelected"
						></el-cascader>
					</div>
				</el-form-item>
				<el-button class="margin-left20" type="primary" size="default " @click="clickSearch" >搜索</el-button>
				<el-button size="default " @click="clickClear" >重置</el-button>
				<el-button type="danger" size="default " @click="clickAdd()" >新增</el-button>
			</div>
			<div class="column-me flex1 overflow-auto">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" border v-loading="loading" stripe="true" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="TcSpecialSubInfo.name" label="素材分类" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="title" label="素材名称" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="封面图" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-image style="width: 150px; height: auto" 
									:src="scope.row.image" 
									:preview-src-list="[scope.row.image]"
									hide-on-click-modal></el-image>
							</template>
						</el-table-column>
						<el-table-column label="素材内容" align="center" show-overflow-tooltip>
							<template #default="scope">
								<video width="150" height="auto" controls>
							      <source :src="scope.row.link"  type="video/mp4">
							    </video>
							</template>
						</el-table-column>
						<el-table-column prop="duration" label="视频时长（秒）" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="sort" label="排序" width="100" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="add_time" label="添加时间" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" align="center" show-overflow-tooltip fixed="right">
							<template #default="scope">
								<div class="row-me center-all">
									<el-button size="small " @click="clickAdd(scope.row.id)" >修改</el-button>
									<el-button type="danger" size="small " @click="clickDel(scope.row)" >删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="handleCurrentChange" background :current-page.sync="pageNo"
                         layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {Plus,Search} from "@element-plus/icons-vue";
import OSS from 'ali-oss'
import { inject,provide } from 'vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  components: {Plus,Search,Editor,Toolbar},
  name: 'MyEditor',
  data() {
    return {
		keyword: '',
		classSelected:'',
		videoKey:1,
		pageNo: 1,
		total: 0,
		loading:false,
		imgloading:false,
		tableData: [],
		classTableData:[],
		editorRef:null,
		addInfo:{
			id: '',
			title: '',
			sort:0,
			spe_sub_id: '',
			detail: '',
			link: '',
			duration:'',
			image: '',	
		},
		boxTitle:'',
		taskUrl:'http://video.chongfenlusvip.cn/',
		file:null,
		infoEditBox:false,
		infoAddBox:false,
		isVideoUpload:false,
		uploading:false,
		aliOssToken:null,
		uploadPercentage:0,
		uploadVideoAliossBtn:false,
		uploadeErrBox:false,
    }
  },
  setup() {
        // 编辑器实例，必须用 shallowRef
        const editorRef = shallowRef()
        const toolbarConfig = {}
        const editorConfig = { 
			placeholder: '请输入内容...',
			MENU_CONF:{
				uploadImage:{
					server:sessionStorage.getItem('GlobalUploadUrl')+'/admin/uploadOss',
					fieldName: 'wangeditor-uploaded-image',
					headers: {
					    Accept: 'text/x-json',
						adminToken: sessionStorage.getItem('token')
					},
					meta: {
					        // 自定义请求的meta
					        'X-Test-Name': 'test'
					      },
					multiple: false, // 是否支持多选文件
					maxFileSize: 5 * 1024 * 1024, // 最大支持文件大小 (5M) 单位为byte
					maxNumberOfFiles: 1, // 最大上传个数
					allowedFileTypes: ['image/*'],
					withCredentials: false,
					onSuccess: function (editor, result, xhr) {
					    console.log('上传成功', result);
					},
					onError: function (editor, err, xhr) {
					    console.log('上传失败', err);
					},
					customInsert(res, insertFn) {
						const dataInfo = res.data;
					    insertFn(dataInfo.url, dataInfo.alt, dataInfo.href)
					},
				}
			}
		}
		// 模拟 ajax 异步获取内容
		onMounted(() => {
			const editor = editorRef.value;
			//editor.config.uploadImgServer = '你的上传地址';
			console.log(editor);
		})
        // 组件销毁时，也及时销毁编辑器
        onBeforeUnmount(() => {
			const editor = editorRef.value
			if (editor == null) return
			editor.destroy()
        })
        const handleCreated = (editor) => {
			editorRef.value = editor // 记录 editor 实例，重要！
			
        }
		
        return {
			editorRef,
			//valueHtml,
			mode: 'default', // 或 'simple'
			toolbarConfig,
			editorConfig,
			handleCreated,
        }
    },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
    this.clickSearch();
	
  },
  // html加载完成后执行。
  mounted() {
	//console.log(config.url);
	
  },
  // 事件方法执行
  methods: {	  
    clickSearch() {
      this.pageNo = 1
      this.getData();
	  this.getClassifyData();
    },
    clickClear() {
      this.keyword = ''
      this.classSelected = ''
      this.clickSearch()
    },
	clickAdd(obj = 0){
		this.$router.push({
			name:'specialtaskAdd',
			query:{
				id:obj
			}
		})
	},
	//列表分页
	handleCurrentChange(pageNo) {
	    this.pageNo = pageNo
	    this.getData()
	},
	

	//==============================================================简单上传【图片上传】【开始】===============================================================
	//上传图片验证
	beforeAvatarUpload(file) {
		console.log(file);
		let types = ['image/jpeg', 'image/jpg', 'image/png'];
		const isImage = types.includes(file.type);
		if (!isImage) {
			this.$message.error('上传图片只支持JPG、JPEG、PNG格式!')
			return false
		}
		const isLt5M = file.size / 1024 / 1024 < 5
		if (!isLt5M) {
			this.$message.error('上传图片不能超过5M')
			return false
		}
		return true
	},
	uploadFile(param) {
		this.imgloading = true;
		try {
			this.$uploadFileAliOss(param.file, res => {
				this.addInfo.image = res;
				this.imgloading = false;
			}, err => {
				console.log(err)
			})
		} catch (error) {
			console.error('上传失败:', error);
		}
	},
	async deleteImage(){
		const url = new URL(this.addInfo.image);
		const imageName = url.pathname.replace(/\//g, "");
		const deleteArr = [imageName];
		const delRess = await this.aliossDelete(deleteArr,1);
		if(delRess){
			this.$message.success('封面素材删除成功！')
			
		}else{
			
		}
	},
	//==============================================================简单上传【图片上传】【结束】===============================================================
	//==============================================================阿里云 ali-oss 【删除开始】===============================================================
	async aliossDelete(arr,type){
		const aliossToken = await this.$getAliOssToken();
		const client = new OSS({
			endpoint: aliossToken.endpoint,
			bucket: aliossToken.bucket,
			accessKeyId: aliossToken.accessKeyId,
			accessKeySecret: aliossToken.accessKeySecret
		});
		try {
		    const result = await client.deleteMulti(arr, {quiet: true});
			if(result.res.status == 200){
				if(type == 1){
					this.addInfo.image = '';	//删除图片
				}else{
					this.addInfo.link = '';		//删除视频
					this.uploadPercentage = 0;
				}
				return true;
			}else{
				this.$message.error('删除失败，请联系管理员！')
				console.log(result);
			}
		  } catch (error) {
			this.$message.error('删除失败，请联系管理员！')
			console.log(error);
			return false;
		  }
	},
	//==============================================================阿里云 ali-oss 【删除结束】===============================================================
	//上传视频验证=================================================大文件分片上传【视频上传】【开始】============================================================
	beforeVideoUpload(file) {
		console.log(file);
		this.file = file.raw;
		console.log(this.file);
		this.isVideoUpload = true;
		const types = ['video/mp4'];
		const isVideo = types.includes(this.file.type);
		if (!isVideo) {
			this.$message.error('上传视频只支持mp4格式!')
			return false
		}
		this.uploadVideoAliossBtn = true;
		return true
	},
	handleExceed(){
		this.$message.warning('只能上传一个文件');
	},
	async uploadVideo(param) {
		this.imgloading = true;
		this.uploading = true;
		this.isVideoUpload = false;
		try {
			const aliossToken = await this.$getAliOssToken();
			const client = new OSS({
		        endpoint: aliossToken.endpoint,
		        bucket: aliossToken.bucket,
		        accessKeyId: aliossToken.accessKeyId,
		        accessKeySecret: aliossToken.accessKeySecret
		    });
			const fileName = this.$generateFileName(this.file);
		    const options = {
		        partSize: 1024 * 1024 * 5, // 分片大小为 5MB
		        parallel: 20, // 并发上传的分片数量
		        progress: (p, cpt, res) => {
		            this.uploadPercentage = Math.round(p * 100);
		        },
		    }; 
			const result = await client.multipartUpload(fileName, this.file, options);
			console.log(result);
			this.$message.success('文件上传成功');
			this.imgloading = false;
			this.uploading = false;
			this.uploadVideoAliossBtn = false;
			this.addInfo.link = this.taskUrl+result.name;
			this.addInfo.etag = result.etag;
			this.videoKey += 1;
			this.uploadPercentage = 0;
		} catch (error) {
			console.error('上传失败:', error);
			this.uploadeErrBox = true;
		}
	},
	async deleteVideo(){
		const url = new URL(this.addInfo.link);
		const videoName = url.pathname.replace(/\//g, "");
		const deleteArr = [videoName];
		const delRess = await this.aliossDelete(deleteArr,2);
		if(delRess){
			this.$message.success('视频素材成功！')
			this.addInfo.duration = 0;
		}
	},
	videoLoadedData(){
		this.addInfo.duration = Math.trunc(this.$refs.videoPlayer.duration);
	},
	//==============================================================大文件分片上传【视频上传】【结束】===============================================================
	//删除
	clickDel(item) {
		this.$confirm("您确定删除吗？删除后无法恢复！", "温馨提示", {
		    confirmButtonText: "确定",
		    cancelButtonText: "取消",
		    type: "warning",
		}).then(() => {
		    this.$post('/admin/specialTaskDel', {
		        id: item.id
		    }).then((res) => {
		        if (res) {
		            this.$message.success('删除成功')
		            this.getData()
		        }
		    }).catch((error) => {
		        console.log(error)
		    })
		}).catch((error) => {
				console.log(error)
		});	
	},	
    //素材table获取数据
    getData() {
		this.loading = true;
		this.$post('/admin/specialTaskList', {
			keyword: this.keyword,
			spe_sub_id: this.classSelected,
			page: this.pageNo
		}).then((res) => {
			if (res) {
				this.total = res.data.all_info_num
				this.tableData = res.data.listInfo
				this.loading = false;
			}
		}).catch((error) => {
			console.log(error)
		})
    },
	//素材分类数据获取
	getClassifyData(){
		this.$post('/admin/specialSubList').then((res) => {
			if (res) {
				this.classTableData = res.data;
			}
		}).catch((error) => {
			console.log(error)
		})
	}
  },
}
</script>

<style lang="scss" scoped>
.userList {
  height: 100%;

  .img-header {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .upload-container {
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }
}
</style>
